import { z } from 'zod';

export const employmentStatusSchema = z.enum([
  'Employed',
  'Student',
  'Retired',
  'SelfEmployed',
  'TemporarilyEmployed',
  'Unemployed'
]);

export const applicantResponseSESchema = z.object({
  id: z.string(),
  email: z.string().email(),
  mobile: z.string(),
  nationalNumber: z.string(),
  employmentStatus: employmentStatusSchema.nullable(),
  finances: z
    .object({
      monthlyIncome: z.number(),
      numberOfChildren: z.number(),
      numberOfPersonsLiving: z.number(),
      monthlyHouseCost: z.number(),
      otherLoanCost: z.number(),
      // Some existing users don't have this field, as it was added later. Therefore, it's nullable.
      transportationCost: z.number().nullable()
    })
    .nullable(),
  addonProducts: z.array(z.enum(['PAYMENT_PROTECTION_INSURANCE', 'ID_PROTECT'])).nullable()
});
